<template>
    <section v-if="hasPermissions(['Census-Vacant-Bed Read', 'Census-Vacant-Bed Write', 'Census-Vacant-Bed Vacant-Bed-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all Patient Beds. To update manually, check off all Vacant beds, then click Update. To upload a file, select Upload File on the Upload Options menu, browse to the file, select the vacant bed file and click open.
            </p>
        </div>

        <div class="bar-container-vacant-beds">
            <input type="date" v-model="form_data.date" v-if="hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="bar-container-vacant-beds__search-bar">
                <div class="input-field my-0"  v-if="bed_codes.length && hasPermissions(['Census-Vacant-Bed Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container-vacant-beds__options">
                <select style="width: 20%" class="input-field custom-select mr-2" v-if="bed_codes.length && hasPermissions(['Census-Vacant-Bed Read'])" v-model="state_beds_filter">
                    <option value="" v-html="'All Beds'"/>
                    <option value="0" v-html="'Occupied Beds'"/>
                    <option value="1" v-html="'Vacant Beds'"/>
                </select>
                <div class="modal__buttons__item w-auto px-3" v-if="hasPermissions(['Census-Vacant-Bed Supervisor-Report']) || hasPermissions(['Census-Vacant-Bed Worksheet-Report'])">
                    <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px;" v-html="'Reports'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                        <span class="sr-only"/>
                    </button>
                    <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                        <a class="dropdown-item" v-html="'Supervisor'" @click="confirmReport(true)" v-if="hasPermissions(['Census-Vacant-Bed Supervisor-Report'])"/>
                        <a class="dropdown-item" v-html="'Worksheets'" @click="confirmReport(false)" v-if="hasPermissions(['Census-Vacant-Bed Worksheet-Report'])"/>
                        <a class="dropdown-item" v-html="'Vacant Beds'" @click="bedsReport(10)" v-if="hasPermissions(['Census-Vacant-Bed Vacant-Beds-Report'])"/>
                        <a class="dropdown-item" v-html="'Ocuppied Beds'" @click="bedsReport(11)" v-if="hasPermissions(['Census-Vacant-Bed Ocuppied-Beds-Report'])"/>
                        <a class="dropdown-item" v-html="'All Beds'" @click="bedsReport(12)" v-if="hasPermissions(['Census-Vacant-Bed All-Beds-Report'])"/>
                    </div>
                </div>
            
                <UploadOptions
                :ref="'file_excel'"
                :empty_format_data="empty_format_data"
                :excel_file_headers="excel_file_headers"
                :file_name="'vacant_bed_code_template_file'"
                @data="upload($event)"
                v-if="hasPermissions(['Census-Vacant-Bed Vacant-Bed-Upload'])"
                />

                <UploadOptionsTXT
                :ref="'file_txt'"
                :empty_format_data="empty_format_data"
                :excel_file_headers="excel_file_headers"
                :file_name="'vacant_bed_code_template_file'"
                @data="upload($event, 'txt')"
                v-if="hasPermissions(['Census-Vacant-Bed Vacant-Bed-Upload'])"
                />

                <button
                    class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2 m-0"
                    v-html="`Update <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`"
                    @click="setBedStatuses(true)"
                    v-if="hasPermissions(['Census-Vacant-Bed Write'])"
                />
        </div>
        </div>
        <div class="row  bar__container" style="margin-top:6px;" v-if="hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="col-md-2 py-0 mb-3 mb-md-0">
                <div class="my-4 mb-md-0 text-center text-md-left vacantbed__list__description">
                    <p class="view__section__text">
                        {{ `Vacant beds: ${count_from} out of ${count_until}` }}
                        <span class="d-block">
                            Occupancy: {{parseInt(ocupancy)}}%
                        </span>
                    </p>
                </div>
            </div>
            
        </div>
        
        <div class="tab-content" v-show="bed_codes.length && hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                ref="dinamic_table"
                                :headers="table_headers"
                                :items="beds"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <!-- <FormModal
            ref="form_modal"
            :title="'New Room'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :bed_numbers="bed_numbers"
            :array_options="array_options"
            :next_walking_number="next_walking_number"
            :from_child="false"
            :save_view="true"
            @unshiftObject="unshift_object($event)"
            @saveView="save_and_view($event)"
        /> -->
        <SupervisorReportModal 
            :title="'Confirmation modal'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :supervisor_report="supervisor_report"
            @supervisorReport="supervisorReport($event)"
            @worksheetsReport="worksheetsReport($event)"
        />

        <WaitingModal/>
        <HelperModal :helps="helps"/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import FormResources from './form_resources'
import SupervisorReportModal from './SupervisorReportModal'
import UploadOptions from '@/components/UploadOptions'
import HelperModal    from    '@/components/HelperModal'
import UploadOptionsTXT from '@/components/UploadOptionsTXT'
import axios from 'axios'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import DinamicTable from '@/components/DinamicTable'
import Resources from './resources'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import moment from 'moment'
import 'vuetify/dist/vuetify.min.css'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "VacantBed",

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTable,
        UploadOptions,
        UploadOptionsTXT,
        UnauthorizedComponent,
        SupervisorReportModal,
        HelperModal
    },

    data() {
        return {
            notyf,
            axios,
            user:       this.get_user(),
            child_href: '/census-vacant-beds/',
            title_page: 'Vacant beds list',
            rest_api: `vacant_dates`,
            ext_rest_api: `bed_statuses`,
            table_headers: Resources.table_headers,
            breadcrumb: Resources.breadcrumb,
            form_data: FormResources.form_data,
            count_from: 0,
            count_until: 0,
            ocupancy: 0,
            single_select: false,
            table_selection: [],
            search: '',
            global_index: '',
            single_object: {},
            vacants: [],
            bed_codes: [],
            array_options: {},
            excel_file_headers: Resources.excel_file_headers,
            empty_format_data: Resources.empty_format_data,
            excel_data: [],
            watch_counter: 0,
            state_beds_filter: '',
            supervisor_report: true,
            helps:                  Resources.helps
        }
    },

    watch: {

        async 'form_data.date'(val)
        {
            this.getBedStatuses(val)
        }

    },
    
    computed:
    {

        beds()
        {
            return this.bed_codes.filter(item => {
                if(this.state_beds_filter != '') 
                {
                    if(this.state_beds_filter == 0)
                    {
                        if(!item.checked)
                        {
                            return item
                        }
                    }
                    else
                    {
                        if(item.checked)
                        {
                            return item
                        }
                    }
                }
                else
                {
                    return item
                } 
            })
        }
    },

    methods: 
    {
        confirmReport(param)
        {
            this.supervisor_report = param
            window.$('#static-supervisor-modal').modal('show')
        },

        async supervisorReport(event)
        {
            const form_data = {
                standard_report_id: 5,
                headers: Resources.supervisor_report_table_headers,
                totals: Resources.supervisor_report_totals,
                format: event.format_report,
                params: {
                    timestamp:  moment().format('MM/DD/YYYY HH:mm:ss')
                }
            }

            form_data.headers[3].show = event.show_discharge_capability
            
            window.$('#static-supervisor-modal').modal('hide')

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                window.$('#static-supervisor-modal').modal('show')
                this.error_handling(response)
            }

            this.loader()
        },

        async worksheetsReport(event)
        {
            const form_data = {
                standard_report_id: 6,
                show_discharge_capability: event.show_discharge_capability,
                format: event.format_report
            }
            
            // form_data.headers[3].show = event.show_discharge_capability
            
            window.$('#static-supervisor-modal').modal('hide')

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                window.$('#static-supervisor-modal').modal('show')
                this.error_handling(response)
            }

            this.loader()
        },

        async bedsReport(event)
        {
            const form_data = {
                headers: Resources.beds_report_table_headers,
                standard_report_id: event,
                format: event.format_report,
                params: {
                    timestamp:  moment().format('MM/DD/YYYY HH:mm:ss')
                }
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()
        },

        async getBedStatuses(val)
        {
            this.loader(true)

            let object = {
                statuses: true,
                date: val,
            }

            const response = await this.get(`${this.ext_rest_api}/${JSON.stringify(object)}`)


            if(response.status)
            {
                let bed_statuses = response.data.bed_statuses

                this.bed_codes.map(item => item.checked = false)

                this.count_from = 0

                if(bed_statuses.length)
                {
                    bed_statuses.forEach((item) => 
                    {
                        let bed = this.bed_codes.find(bed => bed.id === item.bed_id)
                        if(bed)
                        {
                            bed.checked = true
                        }
                    })
                }

                this.countable()
            }
            else
            {
                this.error_handling(response);
            }
            this.watch_counter++

            this.loader()

        },

        async upload(data, type)
        {
            if(!data.length)
            {
                notyf.error('No data available')
                return false
            }

            this.excel_data = []

            let excel_mapping;

            if(type === 'txt')
            {
                excel_mapping = data
            }
            else
            {
                for ( const value of data) 
                {
                    const entity = {}

                    for (const prop in this.excel_file_headers)
                    {
                        entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                    }
                    this.excel_data.push( { ...entity } )
                }
            

                excel_mapping = this.excel_data.map(item => item.code)
            }

            let bedsAvailable = []

            excel_mapping.forEach((item) => 
            {
                let some_bed = this.bed_codes.find(bedcode => bedcode.name == item)
                if(some_bed)
                {
                    bedsAvailable.push(some_bed)
                }
            })

            if(bedsAvailable.length)
            {
                this.bed_codes.map(item => item.checked = false)

                bedsAvailable.forEach((item) => {
                    let lastbed = this.bed_codes.find(prop => prop.id === item.id)
                    lastbed.checked = true
                })

                await this.setBedStatuses(true)
                this.$refs.file_excel.clear_data()
            }
            else
            {
                this.notyfMesg('No beds found', 'error')
                if(excel_mapping.filter((item) => item === undefined).length)
                {
                    await this.setBedStatuses(false)
                    this.$refs.file_excel.clear_data()
                }

            }
        },

        countable()
        {
            this.count_from_occupancy = this.bed_codes.filter(item => !item.checked).length
            this.count_from =  this.bed_codes.filter(item => item.checked).length
            this.count_until = this.bed_codes.length
    
            let cant_x = this.count_from_occupancy
            let semifinal = cant_x * 100
            let final = semifinal/this.count_until
            this.ocupancy = final
        },

        async setBedStatuses(has_data)
        {
            if(has_data)
            {
                this.form_data.beds = this.bed_codes.map((item) => { return { bed_id: item.id, status: item.checked } })
                this.form_data.uploaded = false
            }
            else
            {
                this.form_data.beds = []
                this.form_data.uploaded = true
            }

            this.loader(true)

            let response = await this.post(this.ext_rest_api, this.form_data)

            if(response.status)
            {
                this.countable()
               
                notyf.success('Success')
                this.api_request()
            }

        },

        fill_data(data)
        {
            this.bed_codes = data.beds
            if(this.form_data.date)
            {
                this.getBedStatuses(this.form_data.date)
            }
            else
            {
                this.form_data.date = data.current_date

            }
            
            this.count_until = this.bed_codes.length
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['Census-Vacant-Bed Read', 'Census-Vacant-Bed Write', 'Census-Vacant-Bed Vacant-Bed-Upload']))
        {
            await this.api_request()
        }
        
    },
};
</script>